var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50049 2C9.72978 2.00016 9.93022 2.15644 9.98584 2.37891L10.3911 4H12.4448C12.7515 4.00018 13.0005 4.22397 13.0005 4.5C13.0005 4.76416 12.7722 4.97781 12.4839 4.99609C12.4996 5.09891 12.5043 5.20554 12.4917 5.31445L11.604 12.9609L11.5864 13.0703C11.4731 13.6074 11.0025 13.9998 10.4507 14H5.54932L5.43896 13.9951C4.93528 13.9472 4.51837 13.5715 4.4126 13.0703L4.396 12.9609L3.50732 5.31445C3.49469 5.20562 3.49852 5.09885 3.51416 4.99609C3.22675 4.97696 2.99951 4.76356 2.99951 4.5C2.99951 4.22397 3.24853 4.00018 3.55518 4H5.60986L6.01514 2.37891C6.07081 2.15637 6.27108 2 6.50049 2H9.50049ZM5.54932 12.8232H10.4507L11.3384 5.17676H4.66064L5.54932 12.8232ZM6.99951 7.5C7.27565 7.5 7.49951 7.72386 7.49951 8V10C7.49951 10.2761 7.27565 10.5 6.99951 10.5C6.72355 10.4998 6.49951 10.276 6.49951 10V8C6.49951 7.72399 6.72355 7.50022 6.99951 7.5ZM8.99951 7.5C9.27565 7.5 9.49951 7.72386 9.49951 8V10C9.49951 10.2761 9.27565 10.5 8.99951 10.5C8.72355 10.4998 8.49951 10.276 8.49951 10V8C8.49951 7.72399 8.72355 7.50022 8.99951 7.5ZM6.64111 4H9.35986L9.10986 3H6.89111L6.64111 4Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete1);
export default __webpack_public_path__ + "static/media/Delete1.46ce6c0409aa1cb454a2f66ed8019338.svg";
export { ForwardRef as ReactComponent };